<div class="wrapper">
  <app-delivery-details [data]="data"/>
  <app-actions-section
    class="actions-section w-[455px]"
    [disableAddMenu]="disableAddMenu"
  />
</div>
